import globalDataLayerService from '../../services/analytics/global-data-layer-service';
import { EventActions } from '../../utility/constants';
import { getSearchLink, isPcomSearchAvailable } from '../../utility/pcom-search-helper';
import { h } from '@stencil/core';
import { pureButtonSkeleton } from '../../utility/skeleton';
import { ContextualIconProps, ContextualIconResponse } from '../../utility/constants/app';
import { getRightTheme } from '../../utility/helper';

export default function pcomIcons({
  locale,
  app,
  mode,
  theme,
  isNavigationLoaded
}: ContextualIconProps): ContextualIconResponse {
  function sendDataLayerEvent(url: string) {
    globalDataLayerService.pushDataLayerEvent(EventActions.PCOM_SEARCH_CLICK, {
      componentClick: {
        clickElementId: 'mainmenu.pcom.search',
        clickElementName: 'Pcom Search',
        targetUrl: url
      }
    });
  }

  return {
    leftIcons: isPcomSearchAvailable(locale, app) ? (
      <div class="icon">
        <phn-p-link-pure
          icon="search"
          hide-label="true"
          stretch="true"
          aria="{ 'aria-haspopup': 'dialog', 'aria-label' : 'open the Porsche.com search' }"
          data-test-id="pcom-search-button"
          target={'_self'}
          href={getSearchLink(locale)}
          onClick={() => {
            sendDataLayerEvent(getSearchLink(locale));
          }}
          theme={getRightTheme(theme, mode)}
          style={isNavigationLoaded ? {} : { display: 'none' }}
        />
        {!isNavigationLoaded ? pureButtonSkeleton() : null}
      </div>
    ) : null,
    rightIcons: null
  };
}
